import React, { Component } from "react";
import PropTypes from "prop-types";
import UrlHelpers from "shared/util/UrlHelpers";
import isApp from "shared/util/isApp";
import classnames from "classnames";
import NoQuestionsBlankState from "shared/components/NoQuestionsBlankState";

import MultiPartQuestionWrapper from "./MultiPartQuestionWrapper/";
import BinaryQuestionsWrapper from "apps/questions/containers/BinaryQuestionsWrapper";

import "./App.scss";

if (process.env.PLATFORM === "desktop") {
	require("./App.desktop.scss");
} else {
	require("./App.mobile.scss");
}

class App extends Component {
	static propTypes = {
		onSubmit: PropTypes.func.isRequired,
		onSkip: PropTypes.func.isRequired,
		onFetchQuestion: PropTypes.func.isRequired,

		onSelectAnswer: PropTypes.func.isRequired,
		onDisplayQuestion: PropTypes.func.isRequired,
		onToggleAcceptedAnswer: PropTypes.func.isRequired,
		onSetImportance: PropTypes.func.isRequired,
		onTogglePrivacy: PropTypes.func.isRequired,
		onChangeExplanation: PropTypes.func.isRequired,

		// app props
		error: PropTypes.string,
		isLoading: PropTypes.bool.isRequired,
		isProcessing: PropTypes.bool.isRequired,
		isAtEnd: PropTypes.bool,
		binaryQuestionsMode: PropTypes.bool,
		qid: PropTypes.number,
		questionText: PropTypes.string,
		targetAnswerMode: PropTypes.bool,
		targetAnswerModeOnCancel: PropTypes.func,
		questionsAppStandalone: PropTypes.bool,

		// question props
		question: PropTypes.object.isRequired,
	};

	static defaultProps = {
		qid: null,
		questionText: null,
		isAtEnd: false,
		targetAnswerMode: false,
		targetAnswerModeOnCancel: null,
	}

	componentWillMount() {
		// trigger a question info fetch if we mount without a question
		if (!this.props.question.id && this.props.qid) {
			this.props.onFetchQuestion(this.props.qid);
		}
	}

	componentWillReceiveProps(nextProps) {
		// when we stop fetching questions (i.e., get a new one), kick to top,
		// unless we're in binary questions mode
		if (this.props.binaryQuestionsMode) {
			return;
		}

		if (
			process.env.PLATFORM === "mobile" &&
			this.props.isProcessing &&
			!nextProps.isProcessing
		) {
			if (isApp()) {
				window.App.scrollUp();
			} else {
				window.scrollTo(0, 0);
			}
		}
	}

	render() {
		const {
			question,
			questionText,
			error,
			onSubmit,
			onSkip,
			isLoading,
			isProcessing,
			isAtEnd,
			binaryQuestionsMode,
			targetAnswerMode,
			targetAnswerModeOnCancel,
			questionsAppStandalone,
		} = this.props;

		// desktop passes a prop to the questions app when you're on another user's
		// profile; the apps redirect to a page with the `tuid` url param
		const isTargetAnswerMode = targetAnswerMode || !!(
			isApp() && UrlHelpers.getParam("tuid")
		);

		// if the app has question text provided as a prop but hasn't yet loaded
		// the question, we can use that text to optimistically show the text.
		if (!question.question && questionText) {
			question.question = questionText;
		}

		return (
			<div className={classnames("questionspage", {
				"questionspage--appStandalone": questionsAppStandalone,
				"questionspage--hasError": !!error,
			})}>
				{error &&
					<div className="questionspage-error">
						{error}
					</div>
				}

				<div className="questionspage-questionscontainer">
					{!binaryQuestionsMode && !isAtEnd &&
						<MultiPartQuestionWrapper
							question={question}
							isLoading={isLoading}
							isProcessing={isProcessing}
							onSubmit={onSubmit}
							onSkip={onSkip}
							onDisplayQuestion={this.props.onDisplayQuestion}
							onSelectAnswer={this.props.onSelectAnswer}
							onToggleAcceptedAnswer={this.props.onToggleAcceptedAnswer}
							onSetImportance={this.props.onSetImportance}
							onTogglePrivacy={this.props.onTogglePrivacy}
							onChangeExplanation={this.props.onChangeExplanation}
							targetAnswerMode={isTargetAnswerMode}
							targetAnswerModeOnCancel={targetAnswerModeOnCancel}
						/>
					}

					{!binaryQuestionsMode && isAtEnd &&
						<NoQuestionsBlankState />
					}

					{binaryQuestionsMode &&
						<BinaryQuestionsWrapper />
					}
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/apps/questions/components/App.jsx